/// <amd-module name="TFS/DRITools/RestClient/IdentityPicker" />
import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import {
    IdentitiesGetConnectionsRequestModel,
    IdentitiesGetConnectionsResponseModel,
    IdentitiesGetMruRequestModel,
    IdentitiesGetMruResponseModel,
    IdentitiesPatchMruAction,
    IdentitiesPatchMruResponseModel,
    IdentitiesSearchRequestModel,
    IdentitiesSearchResponseModel
} from "TFS/DRITools/Contracts/IdentityPicker.d";

export interface IIdentityPickerHttpClient extends IVssRestClient {
    beginGetIdentities(identitiesRequest: IdentitiesSearchRequestModel): Promise<IdentitiesSearchResponseModel>;
    beginGetConnections(objectId: string, getRequestParams: IdentitiesGetConnectionsRequestModel): Promise<IdentitiesGetConnectionsResponseModel>;
    beginGetIdentityFeatureMru(
        identityId: string,
        featureId: string,
        getRequestParams: IdentitiesGetMruRequestModel
    ): Promise<IdentitiesGetMruResponseModel>;
    beginPatchIdentityFeatureMru(
        identityId: string,
        featureId: string,
        patchRequestBody: IdentitiesPatchMruAction[]
    ): Promise<IdentitiesPatchMruResponseModel>;
}

class IdentityPickerHttpClient extends RestClientBase implements IIdentityPickerHttpClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    public async beginGetIdentities(identitiesRequest: IdentitiesSearchRequestModel): Promise<IdentitiesSearchResponseModel> {
        return this.beginRequest<IdentitiesSearchResponseModel>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/IdentityPicker/Identities",
            method: "POST",
            body: identitiesRequest
        });
    }

    public async beginGetConnections(
        objectId: string,
        getRequestParams: IdentitiesGetConnectionsRequestModel
    ): Promise<IdentitiesGetConnectionsResponseModel> {
        return this.beginRequest<IdentitiesGetConnectionsResponseModel>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/IdentityPicker/Identities/{objectId}/connections",
            routeValues: {
                objectId: objectId
            },
            queryParams: getRequestParams
        });
    }

    public async beginGetIdentityFeatureMru(
        objectId: string,
        featureId: string,
        getRequestParams: IdentitiesGetMruRequestModel
    ): Promise<IdentitiesGetMruResponseModel> {
        return this.beginRequest<IdentitiesGetMruResponseModel>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/IdentityPicker/Identities/{objectId}/mru/{featureId}",
            routeValues: {
                objectId: objectId,
                featureId: featureId
            },
            queryParams: getRequestParams
        });
    }

    public async beginPatchIdentityFeatureMru(
        objectId: string,
        featureId: string,
        patchRequestBody: IdentitiesPatchMruAction[]
    ): Promise<IdentitiesPatchMruResponseModel> {
        return this.beginRequest<IdentitiesPatchMruResponseModel>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/IdentityPicker/Identities/{objectId}/mru/{featureId}",
            method: "PATCH",
            routeValues: {
                objectId: objectId,
                featureId: featureId
            },
            body: patchRequestBody
        });
    }
}

RestClients.add("IIdentityPickerHttpClient", {
    factory: IdentityPickerHttpClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
